import { CircularProgress, Button as MuiButton, Typography } from '@mui/material'

interface ButtonProps {
  textChange?: React.ReactNode
  disabled?: boolean
  customStyle?: boolean
  text?: string
  classes?: string
  color?: string
  divClass?: string
  extraClass?: string
  type?: 'submit' | 'button' | 'reset'
  variant?: 'contained' | 'text' | 'outlined'
  loading?: boolean
  fullwidth?: boolean
  onClick?: (data?: any) => void
  icon?: React.ReactNode
  iconPosition?: string
  dry?: boolean
}
const Button = ({
  variant = 'contained',
  text = 'Button',
  type = 'button',
  divClass = '',
  color = '',
  disabled = false,
  loading = false,
  fullwidth = false,
  onClick = () => {},
  icon = null,
  iconPosition = 'left',
  customStyle = false,
  extraClass = '',
  textChange,
  classes = 'rounded-[0.625rem] flex gap-1 font-semibold text-[0.938rem] px-[0.2rem] md:px-[1.375rem]  capitalize',
  dry
}: ButtonProps) => {
  const getButtonClasses = () => {
    if (variant === 'contained') {
      return disabled
        ? 'rounded-full bg-disabled text-text-disabled py-[0.30rem]'
        : `${color ? color : 'bg-primary-main'} rounded-full text-white py-[0.30rem] px-[1.25rem]`
    }
    if (variant === 'outlined') {
      return disabled || dry
        ? 'rounded-full border-1 !hover:bg-transparent border-[#616161] bg-disabled text-text-disabled box-border py-[0.25rem]'
        : `rounded-full ${color ? color : 'border-primary-main text-primary-main'} border-action-focus border-1 box-border py-[0.25rem] px-[1.25rem]`
    }
    if (variant === 'text') {
      return disabled
        ? `bg-disabled text-text-disabled py-1.5 `
        : `${color ? color : 'text-primary-main'} rounded-full py-1.5 px-[1.25rem]`
    }
  }
  return (
    <div className={divClass}>
      <MuiButton
        type={type}
        key={text}
        className={` ${disabled && '!cursor-not-allowed'}  ${
          customStyle ? '' : getButtonClasses()
        } ${classes} ${extraClass}`}
        variant={variant}
        onClick={onClick}
        disabled={disabled || loading}
        fullWidth={fullwidth}
        data-modal="true"
      >
        {loading ? (
          <CircularProgress size={25} color="inherit" />
        ) : (
          <>
            {icon && iconPosition === 'left' && icon}
            <Typography variant="buttonLarge_md" className="leading-[1.75rem] normal-case">
              {textChange ?? text}
            </Typography>
            {icon && iconPosition === 'right' && icon}
          </>
        )}
      </MuiButton>
    </div>
  )
}
export default Button
